type ValidateQuestionAnswerStatusObjectKey = {
  [key: string]: {
    name: string
    color: string
  }
}

export const VALIDATE_QUESTION_ANSWER_STATUS_OBJECT: ValidateQuestionAnswerStatusObjectKey = {
  ACCEPTED: {
    name: 'Aprovado',
    color: 'green',
  },
  DECLINED: {
    name: 'Rejeitado',
    color: 'red',
  },
}
